import { render } from "./ChatList.vue?vue&type=template&id=f0b292d6&scoped=true"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"

import "./ChatList.vue?vue&type=style&index=0&id=f0b292d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b292d6"]])

export default __exports__